import api from './api';

const API_URL = '/auth/';

class AuthService {
  login(user) {
    return api
      .post(API_URL + 'login/', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.access) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return api.post(API_URL + 'register/', {
      username: user.username,
      password1: user.password1,
      password2: user.password2
    });
  }
}

export default new AuthService();
